import { useCurrentJob } from '../../../../hooks';

const ContainerComponent = ({ children }) => {
  const { job, isLoading } = useCurrentJob();

  return children({
    job,
    isLoading,
  });
};

ContainerComponent.displayName = 'JobModal-container';

export default ContainerComponent;
